module.exports = __webpack_public_path__ + "static/media/spider-card.e6b1818c.png";